import { ProviderControllerApi, SetCosignPinRequest } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/** Sets or resets the logged-in Co-Signer's Co-Sign PIN. */
export const useSetCosignPin = () =>
  useMutationWithLoading(
    async (params: SetCosignPinRequest & { xTENANTID?: string }) =>
      new ProviderControllerApi(getConfigObject()).setCosignPin(
        params,
        params.xTENANTID
      )
  );
